import { render, staticRenderFns } from "./FormPrompt.vue?vue&type=template&id=b3eb8252&scoped=true&"
import script from "./FormPrompt.vue?vue&type=script&lang=js&"
export * from "./FormPrompt.vue?vue&type=script&lang=js&"
import style1 from "./FormPrompt.vue?vue&type=style&index=1&id=b3eb8252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eb8252",
  null
  
)

export default component.exports